import { PERMISSIONS } from '@helios/authz';
import { useScopedOperationalMutation, useScopedOperationalQuery } from '@/hooks/useScopedOperationalQuery';
import { securityApi } from './security.api';

export function useSecurityCommandCenter() {
  return useScopedOperationalQuery('security', PERMISSIONS.PLATFORM_ADMIN, securityApi.getDashboard, 60_000);
}
export function useRunSecurityScan() {
  return useScopedOperationalMutation('security', PERMISSIONS.PLATFORM_ADMIN, (_input: void, options) => securityApi.runScan(undefined, options));
}
